// Chaves de limites quantitativos
export const SUBSCRIPTION_LIMITS = {
  RESOURCES: 'resources',   // profissionais/recursos (NÃO é 'professionals')
  USERS: 'users',
  ROOMS: 'rooms',
  PROCEDURES: 'procedures', // limite de serviços/procedimentos
};

// Chaves de permissões (liga/desliga)
// platform_confirmation_retry e platform_engagement (docs/features/whatsapp-shared-number/
// plano-segregacao-por-plano.md, 4.4) são lidas no backend de forma fail-closed
// (SubscriptionFeatureService::hasRestrictedPermission — chave ausente/erro = false), diferente
// das demais chaves acima. A tela de automações (Preferences.js) não consulta hasPermission()
// para elas: usa plan_restricted_types/plan_notes vindos de automation_settings/get.php, que já
// aplicam esse fail-closed no backend. Aqui elas existem só para nomear a chave; hasPermission()
// permanece fail-open (ver DEFAULT_PLAN_CONFIG abaixo), então não deve ser usado para bloquear
// envio real.
export const SUBSCRIPTION_PERMISSIONS = {
  MANUAL_WHATSAPP: 'manual_whatsapp',
  FOCUS_NFSE_INTEGRATION: 'focus_nfse_integration',
  PLATFORM_CONFIRMATION_RETRY: 'platform_confirmation_retry',
  PLATFORM_ENGAGEMENT: 'platform_engagement',
  // Número próprio de WhatsApp (Z-API): false só no Essencial
  // (docs/features/subscription/planos-essencial-profissional-2026-10-08.md).
  ZAPI_INTEGRATION: 'zapi_integration',
  // Automações da empresa (hoje só o resumo diário da agenda por e-mail): false só no
  // Essencial. Desde 2026-10-23 nada ao paciente sai pelo número da Gabriela; as
  // automações de WhatsApp dependem do número próprio (plan_restricted_types do backend).
  PLATFORM_AUTOMATIONS: 'platform_automations',
  // Travas por plano (docs/features/subscription/matriz-de-planos.md, seção 6).
  // Profissional+: lista de espera, pacotes, relatório completo, exportação
  // completa e funil de leads. Business: marketing (campanhas, origens e
  // mensagem em massa). O backend bloqueia com 403 BLOCKED_ON_PLAN; aqui é o
  // cadeado visível (usePlanLock).
  WAITING_LIST: 'waiting_list',
  SERVICE_PACKAGES: 'service_packages',
  CLINICAL_REPORTS: 'clinical_reports',
  DATA_EXPORT: 'data_export',
  LEADS_FUNNEL: 'leads_funnel',
  MARKETING: 'marketing',
  // Link de cadastro para o paciente preencher os próprios dados. Profissional+.
  PATIENT_REGISTRATION_LINK: 'patient_registration_link',
};

// Chaves de features com valores específicos
export const SUBSCRIPTION_FEATURE_KEYS = {
  DASHBOARD: 'dashboard',
};

// Valores possíveis para features
export const DASHBOARD_MODES = {
  BASIC: 'basic',
  ADVANCED: 'advanced',
};

// Configuração padrão (fallback permissivo - nunca bloquear por erro)
export const DEFAULT_PLAN_CONFIG = {
  limits: {
    [SUBSCRIPTION_LIMITS.RESOURCES]: null, // null = sem limite
    [SUBSCRIPTION_LIMITS.USERS]: null,
    [SUBSCRIPTION_LIMITS.ROOMS]: null,
    [SUBSCRIPTION_LIMITS.PROCEDURES]: null, // null = sem limite (fallback permissivo)
  },
  permissions: {
    [SUBSCRIPTION_PERMISSIONS.MANUAL_WHATSAPP]: true,
    [SUBSCRIPTION_PERMISSIONS.FOCUS_NFSE_INTEGRATION]: true,
    [SUBSCRIPTION_PERMISSIONS.ZAPI_INTEGRATION]: true,
    [SUBSCRIPTION_PERMISSIONS.PLATFORM_AUTOMATIONS]: true,
    [SUBSCRIPTION_PERMISSIONS.WAITING_LIST]: true,
    [SUBSCRIPTION_PERMISSIONS.SERVICE_PACKAGES]: true,
    [SUBSCRIPTION_PERMISSIONS.CLINICAL_REPORTS]: true,
    [SUBSCRIPTION_PERMISSIONS.DATA_EXPORT]: true,
    [SUBSCRIPTION_PERMISSIONS.LEADS_FUNNEL]: true,
    [SUBSCRIPTION_PERMISSIONS.MARKETING]: true,
    [SUBSCRIPTION_PERMISSIONS.PATIENT_REGISTRATION_LINK]: true,
  },
  features: {
    [SUBSCRIPTION_FEATURE_KEYS.DASHBOARD]: DASHBOARD_MODES.ADVANCED,
  },
};
